// removed by extract-text-webpack-plugin
module.exports = {"message":"message__3PbqN","small":"small__18Jdk","logo":"logo__2Rjp2"};


//////////////////
// WEBPACK FOOTER
// ./routes/home/style.less
// module id = vO8M
// module chunks = 0